<template>
  <div :class="['scroll', { dark: isDark, 'u-fade-out': isHidden, 'u-fade-in': !isHidden }]">
    <a href="#" @click.prevent="scrollTop">
      <div class="progress">
        <div class="progress-bar" :style="scrollProgress"></div>
      </div>
      {{ t('Scroll To Top') }}
    </a>
  </div>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.scroll {
  align-items: center;
  color: $ground-dark;
  display: flex;
  font-weight: 700;
  /* Clears the display cutout when the page is painted edge to edge. It is zero
     on every device without an inset, so the rail does not move. */
  left: calc(1rem + env(safe-area-inset-left, 0px));
  position: fixed;
  top: 50%;
  transform-origin: left top;
  transform: rotate(-90deg) translate(-50%, 0);
  z-index: 10;

  &.dark {
    color: $on-dark-strong;
  }

  a {
    align-items: center;
    color: inherit;
    display: flex;

    .progress {
      background: $line-strong;
      border-radius: 0;
      height: 2px;
      margin-right: 1rem;
      transform: scaleX(-1);
      width: 60px;

      .progress-bar {
        background: $secondary;
        width: 10%;
      }
    }
  }

  @media (max-width: 767.98px) {
    display: none;
  }
}
</style>

<script>
import { useI18n } from 'vue-i18n';
import { scrollToTop } from '@/smoothScroll';
import { useSurface } from '@/composables/useSurface';

export default {
  data() {
    return {
      isHidden: true,
      scrollProgress: 'width: 0%;'
    };
  },

  methods: {
    scrollTop() {
      scrollToTop();
    },

    handleScroll: _.debounce(function () {
      this.isHidden = window.scrollY < 100;
      this.scrollProgress = 'width: ' + ((window.innerHeight + window.scrollY) / document.body.scrollHeight) * 100 + '%;';
      this.syncSurface();
    }, 50)
  },

  created() {
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  mounted() {
    this.handleScroll();
  },

  setup() {
    const { isDark, syncSurface } = useSurface();
    const { t } = useI18n({
      messages: {
        'en-MY': {
          'Scroll To Top': 'Scroll To Top'
        },
        'zh-MY': {
          'Scroll To Top': '回到顶部'
        },
        'ms-MY': {
          'Scroll To Top': 'Tatal Ke Atas'
        }
      }
    });

    return { isDark, t, syncSurface };
  }
};
</script>
